// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".jc-logo[data-v-53d12703]{flex-grow:0;flex-shrink:0}.jc-logo[data-v-53d12703],.jc-logo img[data-v-53d12703]{border-radius:.75rem}", ""]);
// Exports
module.exports = exports;
